function AquamationTypeExplainer({ aquamationType, weight }) {
  let productString = "";

  switch (aquamationType) {
    case "Scattering Service":
      if (weight) productString += weight < 15 ? "$235 - " : "$319 - ";
      productString += "Individual Aquamation Service with Scattering Service";
      break;
    case "Remains Returned":
      if (weight) productString += weight < 15 ? "$375 - " : "$459 - ";
      productString += "Individual Aquamation Service with Remains Returned";
      break;
    case "Private":
      if (weight) productString += weight < 50 ? "$750 - " : "$920 - ";
      productString += "Private Aquamation Service with Remains Returned";
      break;
    default:
  }

  return (
    <>
      {aquamationType === "Remains Returned" && (
        <p>
          <strong>{productString}</strong>
          <br />
          Aquamated remains are returned to you in 1-2 weeks with partitioned
          aquamation service. Your loved one is placed into their own six-sided,
          stainless steel enclosure within the aquamation chamber keeping them
          separate from all other companions who are also present during the
          aquamation process inside of their own six-sided, stainless steel
          enclosure ensuring that you are only receiving your loved one's
          remains.
          <br />
          <br />
          This service includes one fur clipping, one ink paw print, one clay
          paw impression. You can also purchase additional remembrance items or
          opt out of all remembrance items.
          <br />
          <br />
          The aquamated remains are returned to you in our complimentary scatter
          vessel or we have other urn options for purchase.
        </p>
      )}
      {aquamationType === "Scattering Service" && (
        <p>
          <strong>{productString}</strong>
          <br /> Aquamated remains are not returned to you but lovingly
          scattered by us in the Puget Sound. Your loved one is placed into
          their own six-sided, stainless steel enclosure within the aquamation
          chamber keeping them separate from all other companions who are also
          present during the aquamation process inside of their own six-sided,
          stainless steel enclosure.
          <br />
          <br />
          No remembrance item capturing is included with this service but can be
          added for an additional $30 fee.
        </p>
      )}
      {aquamationType === "Private" && (
        <p>
          <strong>{productString}</strong>
          <br />
          Aquamated remains are returned to you in 1-2 weeks with this
          completely private service; only your loved one is present during the
          entire aquamation process.
          <br />
          <br />
          This service includes one fur clipping, one ink print, one clay
          impression, and the aquamated remains returned to you in either our
          complimentary scatter vessel urn or our Paulownia Hardwood Box Urn.
          <br />
          <br />
          Additional paw prints and fur clippings may be added for a fee and we
          have other urn options for purchase.
        </p>
      )}
    </>
  );
}

export default AquamationTypeExplainer;
